<template>
  <div v-if="guide_tutorial_show && guide_tutorial_show.is_active" class="vx-row px-5">
    <div class="vx-col w-full px-8">
      <div class="flex justify-between items-center">
        <p v-if="displayDescription" style="font-size: 24px">
          {{ displayDescription }}
        </p>
        <div class="relative">
          <vx-tooltip text="Play Tutorial Video">
            <img :src="guide_tutorial_show.thumbnail" height="250" width="300" class="rounded object-cover cursor-pointer" :alt="guide_tutorial_show.module" @click="toggleGuideTutorialModal = true" />
            <!-- Play Button Overlay -->
            <div class="absolute inset-0 flex items-center justify-center rounded cursor-pointer" @click="toggleGuideTutorialModal = true">
              <feather-icon icon="PlayCircleIcon" svgClasses="h-16 w-16 mr-4 hover:text-black shadow-sm text-white cursor-pointer" />
            </div>
          </vx-tooltip>
        </div>

        <vs-popup title="Guide Tutorial" name="GuideTutorial" :active.sync="toggleGuideTutorialModal" fullscreen style="z-index: 55000; overflow: hidden">
          <div class="text-center flex justify-center modal-content-body">
            <div class="modal-body w-full h-full">
              <video class="w-9/12 h-8/12" :src="guide_tutorial_show.video" controls controlsList="nodownload"></video>
            </div>
          </div>
        </vs-popup>
      </div>
    </div>
    <vs-divider></vs-divider>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const MODULE_DESCRIPTIONS = {
  'gurudwara-details': 'Update core Gurudwara information including name, location, and contact details.',
  'ragi-schedule': 'Manage Ragi performance schedules for this Gurudwara. Add events with title, performer, and date/time.',
  'katha-schedule': 'Manage Katha schedules for this Gurudwara. Add events with title, speaker, and date/time.',
  'daily-routines': 'Set daily routine timings and activities for this Gurudwara.',
  'contact-us': 'Manage contact details and enquiry information for this Gurudwara.',
  'gurudwara-thumbnail': 'Upload and manage thumbnail images displayed for this Gurudwara.',
  'gurudwara-service': 'Configure services offered by this Gurudwara.',
  faqs: 'Add and manage frequently asked questions for this Gurudwara.',
  'sarai-details': 'Manage Sarai stay properties, rooms, and availability for this Gurudwara.',
  'hotel-details': 'Manage hotel stay properties, rooms, and availability.'
}

function isPlaceholderDescription(value) {
  if (!value || typeof value !== 'string') return true
  const normalized = value.trim().toLowerCase()
  if (!normalized) return true
  if (normalized.length <= 3) return true
  return ['das', 'test', 'demo', 'abc', 'xyz', 'asdf', 'lorem', 'sample'].includes(normalized)
}

export default {
  name: 'show-guide-tutorial',

  /** Props */
  props: {
    module: String
  },

  /** Data */
  data: () => ({
    guide_tutorial_show: null,
    toggleGuideTutorialModal: false
  }),

  /** Import State */
  computed: {
    displayDescription() {
      const apiDescription = this.guide_tutorial_show && this.guide_tutorial_show.description
      if (!isPlaceholderDescription(apiDescription)) {
        return apiDescription.trim()
      }
      return MODULE_DESCRIPTIONS[this.module] || ''
    }
  },

  /** CTA functions */
  methods: {
    /** API Iport */
    ...mapActions('guideTutorial', {
      getGuideTutorial: 'show'
    })
  },

  /** Watchers */
  watch: {},

  /** On Rendering */
  async mounted() {
    const { data } = await this.getGuideTutorial(this.module)
    this.guide_tutorial_show = data.data
    // this.guide_tutorial_show = data.find((item) => item.module === this.module)
  }
}
</script>
